/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';

import { CopyText, Modal } from '../../../../UiKit';
import { WFHCall } from '../../../commons';
import { ValetCallClickEvent } from '../../../../analytics/call-logging/events';
import { formatDateTimeIST } from '../../../../utils/UtilFunctions';
import { WALKER_CALLED_TO, WALKER_CALLEE_ROLE } from '../constants';

const headerCellClass =
  'tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis';
const bodyCellClass =
  'tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-snug';

export const WalkerDetails = ({ walker, orderId, userId, cartId }) => {
  const [showWalkerDetails, setShowWalkerDetails] = useState(false);

  if (!walker?.name) return null;

  const walkerPhoneNumber = walker?.phone_number || '';

  return (
    <>
      <div
        className='tw-text-300 tw-font-medium tw-text-base-green tw-cursor-pointer tw-leading-none'
        onClick={() => setShowWalkerDetails(true)}
      >
        View Walker Details
      </div>
      <Modal
        isVisible={showWalkerDetails}
        padding={0}
        paddingTop={'1rem'}
        type='huge'
        height='100%'
        maxHeight='80vh'
        containerStyles={{ margin: '12px 0 20px 0', padding: '0 20x' }}
        titleComponent={
          <span className='tw-text-[2rem] tw-font-medium tw-text-zinc-600'>
            Walker Assignment Details
          </span>
        }
        handleClose={() => setShowWalkerDetails(false)}
      >
        <div className='tw-overflow-hidden'>
          <div className='tw-flex tw-items-center tw-w-fit tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-1 tw-border-solid tw-border-grey-300/70 tw-mx-10 tw-overflow-hidden'>
            <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
              <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
                <thead className='tw-rounded-xl'>
                  <tr className='tw-rounded-2xl'>
                    <th className={`tw-w-[25%] ${headerCellClass}`}>Walker</th>
                    <th className={`tw-w-[16%] ${headerCellClass}`}>
                      Phone Number
                    </th>
                    <th className={`tw-px-1 tw-w-[18%] ${headerCellClass}`}>
                      Assigned At
                    </th>
                    <th className={`tw-px-1 tw-w-[18%] ${headerCellClass}`}>
                      Client Type
                    </th>
                    <th className={`tw-px-1 tw-w-[18%] ${headerCellClass}`}>
                      Trip ID
                    </th>
                    <th className='tw-px-1 tw-w-[13%] tw-bg-blue-200 tw-text-grey-800 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'>
                      Batched
                    </th>
                  </tr>
                </thead>
                <tbody className='tw-bg-white'>
                  <tr className='tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'>
                    <td className='tw-px-2 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-rounded-bl-xl'>
                      <div className='tw-flex tw-flex-col tw-items-center tw-gap-2'>
                        <span
                          className='tw-font-medium tw-text-[1.5rem] tw-leading-none'
                          data-dd-privacy='mask'
                        >
                          {walker?.name}
                          {walker?.label && (
                            <span className='tw-rounded-lg tw-text-[1.2rem] tw-px-2 tw-py-1 tw-font-medium tw-leading-none tw-bg-teal-100 tw-text-teal-600 tw-whitespace-nowrap tw-m-2'>
                              {walker.label}
                            </span>
                          )}
                        </span>
                        {walker?.driver_fe_id ? (
                          <CopyText
                            title={walker.driver_fe_id}
                            customClass='tw-text-grey-800 tw-text-[1.4rem] tw-font-medium'
                            position='right'
                          />
                        ) : null}
                      </div>
                    </td>
                    <td
                      className='tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200'
                      data-dd-privacy='mask'
                    >
                      {walkerPhoneNumber ? (
                        <div className='tw-flex tw-justify-center tw-gap-2 tw-items-center'>
                          <CopyText
                            title={walkerPhoneNumber}
                            orderId={orderId}
                            userId={userId}
                            masking={true}
                            maskingCount={4}
                            maskEverything={true}
                            calledTo={WALKER_CALLED_TO}
                          />
                          <WFHCall
                            orderId={orderId}
                            userId={userId}
                            title={walkerPhoneNumber}
                            calledTo={WALKER_CALLED_TO}
                            role={WALKER_CALLEE_ROLE}
                            valetId={walker?.driver_fe_id}
                            sendJumboEvent={true}
                            jumboEventFunc={ValetCallClickEvent}
                            JumboEventProperties={{
                              valet_name: walker?.name,
                              valet_number: walkerPhoneNumber,
                              valet_id: walker?.driver_fe_id,
                              is_walker: true,
                              is_new_ui: true,
                            }}
                            cartId={cartId}
                          />
                        </div>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td className={bodyCellClass}>
                      {formatDateTimeIST(walker?.assigned_at)}
                    </td>
                    <td className={bodyCellClass}>
                      {walker?.client_type || '-'}
                    </td>
                    <td className={bodyCellClass}>
                      {walker?.trip_id ? (
                        <div className='tw-flex tw-justify-center'>
                          <CopyText title={walker.trip_id} position='right' />
                        </div>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td className='tw-px-1 tw-rounded-br-xl tw-leading-snug'>
                      {walker?.is_batched ? 'Yes' : 'No'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
